import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import * as types from '@survey/store/types'
import * as dateUtil from '@appbase/util/date-helper'
import Paginate from '@board/components/common/Paginate.vue';
import { IEDate } from '@appbase/util/date-helper';

@Component({
    components: {
        Paginate
    },
    computed: {
        ...mapGetters({
            pageSet: types.SURVEY_PAGESET,
            list: types.SURVEY_LIST,
            menuPermission : types.SURVEY_MENU_PERMISSIONS,
        }),
    }
})

export default class SurveyGridTable extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ default:1, type: Number }) type!: number  
    @Prop({ type: Boolean, default: false }) isAdmin!: boolean;
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    list!: survey.SurveyListResponse
    menuPermission!: survey.MenuPermissions
    pageSet!: survey.SurveyListRequest
  
    selected: survey.SurveyListItem[] = []
    allSelected: boolean = false
    totalPage: number = 0;

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch('selected')
    onChangedSelected(){
        if(this.selected.length === this.list.surveyLists.length){
            this.allSelected = true;
        }else{
            this.allSelected = false;
        }
        this.$emit('selected', this.selected)
    }

    @Watch('list')
    onListChanged(newVal: survey.SurveyListResponse) {
        this.totalPage = Math.ceil(newVal.totalCount / this.pageSet.rowCount)
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    selectAll(){
        if(this.allSelected){
            this.selected = this.list.surveyLists              
                // .map(s => s.surveyId);

            this.$emit('selected', this.selected)                
        }else {
            this.selected = [];
        }
    }
    
    convertDate(date: string) {
        if(!date){
            date = new Date().toString();
        }
        return dateUtil.uGetDateFormat("yyyy.MM.DD", new Date(date))
    }

    convertCreatedDate(date: string) {
        return dateUtil.uGetDateFormat("yyyy.MM.DD H:i", new Date(date))
    }

    getStatusText(row: survey.SurveyListItem) {
        var endDate = IEDate(row.endDate);
        endDate.setHours(24, 59, 59);

        var expired = (new Date()).getTime() - endDate.getTime() > 0;
        var surveyStatus: number = expired ? 3 : row.surveyStatus;        

        if(!row.isApproval) {
            if(row.isComposing) return "작성중";
            else if(row.isApproval==false) return "반려됨";
            else return "승인대기중";
        } else {
            if(row.isCompleted && surveyStatus!=3)
                return "참여완료";

            switch(surveyStatus) {
                case 1: return "대기중";
                case 2: return "진행중";
                case 3: return "종료";
            }
        }
    }

    getStatusClass(row: survey.SurveyListItem) {  
        var endDate = IEDate(row.endDate);
        endDate.setHours(24, 59, 59);

        var expired = (new Date()).getTime() - endDate.getTime() > 0;
        var surveyStatus: number = expired ? 3 : row.surveyStatus;    
        
        if(!row.isApproval) {
            if(row.isApproval==null)
            return { 'badge-lightgray': true };
            else
            return { 'badge-red' : true };
        } else {
            switch(surveyStatus) {
                case 1: return { 'badge-lightgray': true };
                case 2: return { 'badge-green': true };
                case 3: return { 'badge-lightgray': true };
            }
        }
    }

    convertStatus(data: survey.SurveyListItem, isClass: boolean = false) {
        var returnString = ""
        switch(data.surveyStatus){
            case 1:
                returnString = isClass ? "badge-lightgray" : this.$t('게시대기').toString()
                break
            case 2:
                let spanDays = this.getSpanDays(new Date(data.endDate))

                if(spanDays > -1 && spanDays < 4){
                    returnString = isClass ? `badge-yellow` : `D-${spanDays == 0 ? 'day' : spanDays}`
                }else{ //진행중일 때 종료3일전부터는 d-3 으로 표시
                    returnString = isClass ? "badge-green" : this.$t('진행중').toString()
                }
                break
            case 3:
                returnString = isClass ? "badge-lightgray" : this.$t('종료').toString()
                break
        }
         
        return returnString
    }

    getSpanDays(endDate : Date){
        endDate.setHours(23,59,59,999); //endOfDays
        const now = new Date()

        var diff = endDate.getTime() - now.getTime();     
        let days = Math.floor(diff / (1000 * 60 * 60 * 24));

        return days
    }


    goRead(surveyId : number){         
        this.$router.push({
            name : "SurveyRead",
            query: { 
                type : this.$route.query.type,
                MENUID : this.$route.query.MENUID,
                surveyId: surveyId.toString() 
            }
        })
    }

    pageClickCallback(pageNum : number){     
        this.$emit('search', <survey.SurveyListRequest>{
            ...this.pageSet,
            pageNumber: pageNum
        })
    }

    //선택 전체 해제
    removeSelected(){
        this.selected = [];
    }
}
